import SpriteSymbol from "../../../../ProSpace/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../ProSpace/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-down-left",
  "use": "icon-arrow-down-left-usage",
  "viewBox": "0 0 11 10",
  "content": "<symbol viewBox=\"0 0 11 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-down-left\">\n<path d=\"M0 0H11H0ZM11 9C11 10.1046 10.1046 11 9 11H1C-0.104569 11 -1 10.1046 -1 9H1H10C10.5523 9 11 9 11 9ZM1 11C-0.104569 11 -1 10.1046 -1 9V2C-1 0.895431 -0.104569 0 1 0C1 0 1 0.447715 1 1V9V11ZM11 0V10V0Z\" fill=\"#E0E7F4\" mask=\"url(#path-1-inside-1_5043_406482)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol